import { useState, useEffect, Dispatch, SetStateAction, useRef } from "react";

type Response<T> = [T, Dispatch<SetStateAction<T>>];

export default function usePersistentState<T>(
  key: string,
  initialState?: T
): Response<T> {
  const keyName = `state.${key}`;
  const [state, setState] = useState<T>(initialState);
  const firstLoad = useRef(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const storageValue = localStorage.getItem(keyName);

      if (storageValue) setState(JSON.parse(storageValue));
    }
  }, []);

  useEffect(() => {
    if (firstLoad.current) {
      if (state !== undefined) localStorage.setItem(keyName, JSON.stringify(state));
      else localStorage.removeItem(keyName);
    }

    firstLoad.current = true;
  }, [keyName, state]);

  return [state, setState];
}
